import type { ReactNode } from "react";

/** Shared filter strip under PageHeader — plan/27 / plan/35. */
export function AdminFilters(props: { children: ReactNode }) {
  return (
    <div
      className="mt-5 flex w-full flex-wrap items-center rounded-[var(--radius-xl)] border border-[var(--color-border)]/90 bg-[var(--color-card)]/85 p-1.5 shadow-[var(--shadow-soft)]"
      style={{ gap: "var(--desk-filter-gap)" }}
    >
      {props.children}
    </div>
  );
}

export const adminFilterControlClass =
  "min-h-11 rounded-lg border-0 bg-transparent px-3 py-2 text-sm text-[var(--color-foreground)] outline-none transition-colors focus-visible:ring-2 focus-visible:ring-[var(--color-ring)]";
